import { JsonSerializable } from '@/util/object/JsonSerializable'
import { FulfillmentType } from '@/cowboy/EnumTypes'
import { ItemAttributeResponse } from '@/cowboy/order_info/object/ItemAttributeResponse'

export class RewardLinkItemResponse extends JsonSerializable {
  /** @type {string} */
  #utid
  /** @type {FulfillmentType} */
  #fulfillmentType
  /** @type {boolean} */
  #isExpirable
  /** @type {Array<ItemAttributeResponse>} */
  #attributes

  constructor (jsonObject) {
    super()
    this.#utid = jsonObject.utid
    this.#fulfillmentType = FulfillmentType.fromJSON(jsonObject.fulfillmentType)
    this.#isExpirable = Boolean(String(jsonObject.isExpirable).toLowerCase() === 'true')
    this.#attributes = jsonObject.attributes?.map(attribute => ItemAttributeResponse.fromJSON(attribute)) || []
    Object.freeze(this)
  }

  /**
   * Reward links item identifier
   * @return {string}
   */
  get utid () {
    return this.#utid
  }

  /**
   * Reward links fulfillment type
   * @return {FulfillmentType}
   */
  get fulfillmentType () {
    return this.#fulfillmentType
  }

  /**
   * Is the Reward link expirable
   * @return {boolean}
   */
  get isExpirable () {
    return this.#isExpirable
  }

  /**
   * Reward links attributes to determine type
   * @return {Array<ItemAttributeResponse>}
   */
  get attributes () {
    return this.#attributes
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      utid: this.#utid,
      fulfillmentType: this.#fulfillmentType?.toJSON(),
      isExpirable: this.#isExpirable,
      attributes: this.#attributes?.map(attribute => attribute.toJSON())
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {RewardLinkItemResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new RewardLinkItemResponse(jsonObject)) || undefined
  }
}
